export function htmlToText(html) {
  if (!html) return "";
  // DOMParser محتوا را به متن تبدیل می‌کند (entityها هم decode می‌شوند)
  if (typeof window !== "undefined" && "DOMParser" in window) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.body.textContent || "";
  }
  // فallback ساده برای SSR: حذف تگ‌ها (entityها decode نمی‌شوند)
  return html.replace(/<[^>]+>/g, "").trim();
}